import loginPage from '../pages/Login.vue'
import notFoundPage from '../pages/NotFound.vue'
import dashboardPage from '../pages/dashboard/DashboardPage.vue'
import outletPage from '../pages/outlet/OutletPage.vue'
import paymentMethodPage from '../pages/paymentMethod/PaymentMethodPage.vue'
import sellerPage from '../pages/seller/SellerPage.vue'
import productPage from '../pages/products/ProductPage.vue'
import registerPage from '../pages/register/RegisterPage.vue'
import cashierPage from '../pages/cashier/CashierPage.vue'
import sellReportPage from '../pages/sellReport/SellReportPage.vue'
import totalRevenuePage from '../pages/totalRevenue/TotalRevenuePage.vue'
import revenueByCustomerPage from '../pages/revenueByCustomer/RevenueByCustomerPage.vue'
import revenueByOutletPage from '../pages/revenueByOutlet/RevenueByOutletPage.vue'
import refundPage from '../pages/refund/RefundPage.vue'
import discountPage from '../pages/discount/DiscountPage.vue'
import fulfillmentPage from '../pages/fulfillment/FulfillmentPage.vue'
import orderByOrderStatusPage from '../pages/orderStatus/OrderByOrderStatusPage.vue'
import orderByPaymentStatusPage from '../pages/paymentStatus/OrderByPaymentStatusPage.vue'
import averageDurationPage from '../pages/averageDuration/AverageDurationPage.vue'
import averageOrderValuePage from '../pages/averageOrderValue/AverageOrderValuePage.vue'
import numberOfOrdersPage from '../pages/numberOfOrder/NumberOfOrdersPage'
import netRevenuePage from '../pages/netRevenue/NetRevenuePage'
import globalPage from '../pages/global/GlobalPage'
import revenueByCategoryPage from '../pages/revenueByCategory/RevenueByCategoryPage'
import averageItemPerOrderPage from '../pages/averageItemPerOrder/AverageItemPerOrderPage'
import taxPage from '../pages/tax/taxPage'
import productSoldPage from '../pages/productSold/ProductSoldPage'
import revenueByProduct from '../pages/revenueByProduct/revenueByProductPage'
import productSoldByCategoryPage from '../pages/productSoldByCategory/ProductSoldByCategoryPage'
import timeInStatusPage from '../pages/timeInStatus/TimeInStatusPage.vue'
import tippings from '../pages/tippings/Tippings.vue'
import salesOrder from '../pages/salesOrder/SalesOrderPage.vue'

import { DOMAIN_TITLE } from '../.env'

export const routes = [
  {
    path: '/',
    name: 'index',
    redirect: { name: 'dashboard' },
    meta: { title: `${DOMAIN_TITLE} | home`, requireLogin: true }
  },
  {
    path: '/#/dashboard',
    name: 'dashboard',
    component: dashboardPage,
    meta: { title: `${DOMAIN_TITLE} | dashboard`, requireLogin: true }
  },
  {
    path: '/#/product',
    name: 'product',
    component: productPage,
    meta: { title: `${DOMAIN_TITLE} | product`, requireLogin: true }
  },
  {
    path: '/#/seller',
    name: 'seller',
    component: sellerPage,
    meta: { title: `${DOMAIN_TITLE} | seller`, requireLogin: true }
  },
  {
    path: '/#/outlet',
    name: 'outlet',
    component: outletPage,
    meta: { title: `${DOMAIN_TITLE} | outlet`, requireLogin: false }
  },
  {
    path: '/#/payment',
    name: 'payment',
    component: paymentMethodPage,
    meta: { title: `${DOMAIN_TITLE} | payment`, requireLogin: true }
  },
  {
    path: '/#/register',
    name: 'register',
    component: registerPage,
    meta: { title: `${DOMAIN_TITLE} | register`, requireLogin: true }
  },
  {
    path: '/#/cashier',
    name: 'cashier',
    component: cashierPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/total-revenue',
    name: 'totalRevenue',
    component: totalRevenuePage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/revenue-by-customer',
    name: 'revenueByCustomer',
    component: revenueByCustomerPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/revenue-by-outlet',
    name: 'revenueByOutlet',
    component: revenueByOutletPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/refund',
    name: 'refund',
    component: refundPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/discount',
    name: 'discount',
    component: discountPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/fulfillment',
    name: 'fulfillment',
    component: fulfillmentPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/average-order-value',
    name: 'averageOrderValue',
    component: averageOrderValuePage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/number-of-orders',
    name: 'numberOfOrders',
    component: numberOfOrdersPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/order-status',
    name: 'orderStatus',
    component: orderByOrderStatusPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/payment-status',
    name: 'paymentStatus',
    component: orderByPaymentStatusPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/average-duration',
    name: 'averageDuration',
    component: averageDurationPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/time-in-status',
    name: 'timeInStatus',
    component: timeInStatusPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/tippings',
    name: 'tippings',
    component: tippings,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/sales-order',
    name: 'salesOrder',
    component: salesOrder,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/global',
    name: 'global',
    component: globalPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/global-stores',
    name: 'global-stores',
    component: globalPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/net-revenue',
    name: 'netRevenue',
    component: netRevenuePage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/revenue-by-category',
    name: 'revenueByCategory',
    component: revenueByCategoryPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/average-item-per-order',
    name: 'averageItemPerOrder',
    component: averageItemPerOrderPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/tax',
    name: 'tax',
    component: taxPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/product-sold',
    name: 'productSold',
    component: productSoldPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/revenue-by-product',
    name: 'revenueByProduct',
    component: revenueByProduct,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  {
    path: '/#/product-sold-by-category',
    name: 'productSoldByCategory',
    component: productSoldByCategoryPage,
    meta: { title: `${DOMAIN_TITLE} | cashier`, requireLogin: true }
  },
  { path: '/#/sales-report', name: 'salesReport', component: sellReportPage, meta: { title: `${DOMAIN_TITLE} | sales report`, requireLogin: true } },
  {
    path: '/#/login',
    name: 'login',
    component: loginPage,
    meta: { title: `${DOMAIN_TITLE} | login`, authLayout: true }
  },
  {
    path: '*',
    component: notFoundPage,
    meta: { title: `${DOMAIN_TITLE} | not found` }
  }
]
